import { Controller } from '@hotwired/stimulus'
import { emit, on } from '../lib/events'

export default class extends Controller {
  static targets = ['togglee']
  static values = {
    emitable: String,
    emitableDetail: Object,
    sendOnLoad: { type: Boolean, default: false },
    autoclose: { type: Boolean, default: false },
    maxHeight: String,
  }

  initialize = () => {
    if (this.sendOnLoadValue) {
      on('turbo:frame-load', this.sendEvent())
    }
  }

  toggle = () => {
    this.toggleElements(this.toggleeTargets)
  }

  // alias for toggle, we need to change that, toggle#toggle is not good
  perform = () => {
    this.toggleElements(this.toggleeTargets)
  }

  toggleElements = (elements) => {
    elements.forEach((element) => {
      const toggleClasses = element.dataset.toggleClasses

      if (toggleClasses) {
        const classNames = element.dataset.toggleClasses.split(' ')
        classNames.forEach(className => element.classList.toggle(className))
      }
    })
  }

  expand = () => {
    this.toggleeTargets.forEach((element) => {
      if (element.style.maxHeight === '0px') {
        element.style.maxHeight = this.maxHeightValue
        const svg = this.element.getElementsByTagName('svg')[0]
        svg.style.transition = 'transform .4s ease-in-out'
        svg.style.transform = 'rotate(180deg)'
      }
      else {
        element.style.maxHeight = '0px'
        const svg = this.element.getElementsByTagName('svg')[0]
        svg.style.transform = 'rotate(0)'
      }
    })
  }

  sendEvent = () => {
    emit(this.emitableValue, {
      bubbles: true,
      detail: this.emitableDetailValue,
    })
  }

  toggleGroup = (event) => {
    const target = event.currentTarget
    const selector = target.dataset.selector
    const elements = this.groupElements(selector)

    this.toggleElements(elements)
  }

  groupElements = (selector) => {
    if (this.autocloseValue) {
      return this.handleOpenClosed(selector)
    }
    else {
      return this.element.querySelectorAll(`[data-selector="${selector}"]`)
    }
  }

  handleOpenClosed = (selector) => {
    const selectedElements = this.element.querySelectorAll(`[data-selector="${selector}"]`)
    const selectedOpen = [...selectedElements].filter(ele => ele.dataset.toggleOpen === 'true')

    if (selectedOpen.length) {
      selectedElements.forEach(ele => ele.setAttribute('data-toggle-open', 'false'))

      return selectedElements
    }
    else if (this.allOpen.length) {
      const combined = this.element.querySelectorAll(`[data-selector="${selector}"], [data-toggle-open="true"]`)
      this.allOpen.forEach(ele => ele.setAttribute('data-toggle-open', 'false'))
      selectedElements.forEach(ele => ele.setAttribute('data-toggle-open', 'true'))

      return combined
    }
    else {
      selectedElements.forEach(ele => ele.setAttribute('data-toggle-open', 'true'))
      return selectedElements
    }
  }

  get allOpen() {
    return this.element.querySelectorAll('[data-toggle-open="true"]')
  }
}
